import { AppState } from '@state/app/app.state';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';

export const LoadedFromLeapGuard: CanActivateFn = () =>
	inject(Store).selectSnapshot(AppState.loadedFromLeap);
